import { createFeatureSelector } from '@ngrx/store';
import { ApplicationStates } from '../../../reducers/index.config';

export class FilterState {
  demo: EntityFilter;
}

export class EntityFilter {
  fields?: EntityFilterNodeState;
}

export class EntityFilterNodeState {
  filters: any[];
  loaded: boolean;
  loading: boolean;
  errorMessage?: string;
  error?: any;
}

const initEntityFilter = {
  fields: {
    filters: undefined,
    loaded: false,
    loading: false,
  },
};

export const initialFilterState: FilterState = {
  demo: { ...initEntityFilter },
};

export const getFilterState = createFeatureSelector<FilterState>(ApplicationStates.FILTER);
